import { FilterMatchMode } from "primereact/api";

export class MatrizTransaccional {
    model = {
        id: {
            value: null,
            export: false
        },
        nombre: {
            value: '',
            header: 'Nombre',
            required: 'Campo requerido',
            maxLength: 'Máximo 300 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 300,
            min: 4,
            filterField: 'nombre',
            table: true,
            filter: true,
            sort: true,
            matchMode: FilterMatchMode.CONTAINS,
            headerStyle: { width: '175px' }
        },
        codigo: {
            value: '',
            header: 'Código',
            required: 'Campo requerido',
            maxLength: 'Máximo 50 caracteres',
            minLength: 'Mínimo 4 caracteres',
            table: true,
            max: 100,
            min: 4,
            filter: true,
            filterField: 'codigo',
            matchMode: FilterMatchMode.CONTAINS,
            headerStyle: { width: '175px' }
        },
        observacion: {
            value: '',
            header: 'Observacion',
            required: 'Campo requerido',
            maxLength: 'Máximo 300 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 300,
            min: 4,
            filterField: 'nombre',
        },
        fecha_inicio: {
            value: null,
            header: 'Fecha de inicio',
            required: 'Campo requerido',
            maxLength: 'Máximo 100 caracteres',
            minLength: 'Mínimo 1 caracteres',
            table: true,
            max: 100,
            min: 1,
            headerStyle: { width: '175px' }
        },
        fecha_fin: {
            value: null,
            header: 'Fecha de fin',
            required: 'fecha es requerido',
            optionLabel: 'empresa',
            export: true,
            table: true,
            headerStyle: { width: '175px' }
        },
        empresa: {
            value: null,
            header: 'Empresa',
            table: true,
            filter: true,
            filterField: 'empresa',
            matchMode: FilterMatchMode.CONTAINS,
            headerStyle: { width: '325px' }
        },
        estado: {
            value: '',
            header: 'Estado',
            table: true,
            filter: true,
            filterField: 'estado',
            matchMode: FilterMatchMode.CONTAINS,
            headerStyle: { width: '175px' }
        },
    }

    optionLabel = 'nombre';

    template = (body, info) => {
        return {
            pageOrientation: 'landscape',
            pageSize: 'A2',
            pageMargins: [40, 80, 40, 40],
            header: {
                margin: [40, 20, 40, 20],
                columns: [
                    info.logo
                        ? { image: info.logo, width: 80, alignment: 'left', margin: [0, 0, 10, 0] }
                        : { text: '', width: 80, alignment: 'left', margin: [0, 0, 10, 0] },
                    {
                        stack: [
                            { text: 'Monitoreo Transaccional', style: 'header' },
                            { text: info.razon_social, style: 'subtitle' },
                            {
                                text: [
                                    { text: 'Periodo Analizado: ', bold: true },
                                    { text: `Desde ${info.fecha_inicio} hasta ${info.fecha_fin}` }
                                ], style: 'periodo'
                            },
                        ],
                        width: '*'
                    },
                    { text: '', width: 80, alignment: 'right', margin: [0, 0, 0, 10] }
                ]
            },
            footer: (currentPage, pageCount) => ({
                columns: [
                    {
                        stack: [
                            {
                                text: [
                                    { text: 'Fecha de creación del monitoreo: ', bold: true },
                                    { text: info.fecha_creacion || '-' }
                                ],
                                fontSize: 8,
                                margin: [0, 0, 0, 2],
                                alignment: 'left'
                            },
                            {
                                text: [
                                    { text: 'Fecha de generación del reporte: ', bold: true },
                                    { text: info.fecha_generacion || '-' }
                                ],
                                fontSize: 8,
                                alignment: 'left'
                            }
                        ],
                        width: '33%'
                    },
                    { text: `Página ${currentPage} de ${pageCount}`, alignment: 'center', fontSize: 9, width: '34%' },
                    { text: `Estado de monitoreo: ${info.estado || '-'}`, alignment: 'right', fontSize: 9, width: '33%' }
                ],
                margin: [40, 10, 40, 0]
            }),
            content: [
                {
                    table: {
                        widths: ['*', '*', '*'],
                        body: [
                            [
                                { text: 'Nombre del Monitoreo', style: 'th', fillColor: '#e0e0e0' },
                                { text: 'Código de referencia', style: 'th', fillColor: '#e0e0e0' },
                                { text: 'Detalle del monitoreo', style: 'th', fillColor: '#e0e0e0' }
                            ],
                            [
                                { text: info.nombre, style: 'td' },
                                { text: info.codigo, style: 'td' },
                                { text: info.observacion, style: 'td' }
                            ]
                        ]
                    },
                    layout: {
                        hLineColor: '#ccc',
                        vLineColor: '#ccc',
                        paddingLeft: () => 6,
                        paddingRight: () => 6,
                    },
                    margin: [0, 0, 0, 15]
                },
                {
                    // margin: [60, 0, 60, 0], para centrar la tabla
                    table: {
                        headerRows: 1,
                        body: body
                    },
                    layout: {
                        fillColor: null,
                        hLineColor: '#ccc',
                        vLineColor: '#ccc',
                        paddingLeft: () => 4,
                        paddingRight: () => 4,
                    }
                }
            ],
            styles: {
                header: { fontSize: 16, bold: true, alignment: 'center', color: '#003366', margin: [0, 0, 0, 5] },
                th: { bold: true, fontSize: 9, alignment: 'center', fillColor: '#eeeeee' },
                td: { fontSize: 9, alignment: 'center' },
                subtitle: { fontSize: 12, bold: true, color: '#003366', margin: [0, 0, 0, 5] },
                periodo: { fontSize: 9, italics: true, color: '#222' },
            },
            defaultStyle: {
                alignment: 'center',
                verticalAlignment: 'middle',
                fontSize: 7
            }
        };
    };
}
